<template>
  <div class="wrapper">
    <div class="detail">
      <div class="detail-title">{{$t('integral')}}{{$t('detail')}}</div>
      <el-table :data="pointList" style="width: 100%" v-if="pointList.length>0">
        <el-table-column prop="ctime" :label="$t('time')" width="200" align="center"></el-table-column>
        <el-table-column prop="num" :label="$t('integral')" width="100" align="center"></el-table-column>
        <el-table-column prop="type" :label="$t('action')" align="center"></el-table-column>
        <el-table-column prop="remarks" :label="$t('explain')" align="center"></el-table-column>
        <el-table-column prop="balance" :label="$t('availableIntegral')" align="center"></el-table-column>
      </el-table>
      <div v-else class="detail-nodata">{{$t('integralTips')}}~</div>
    </div>
    <div v-if="pointList.length>0">
      <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  name: "Point",
  components: { Pagination },
  props: {},
  data() {
    return {
      page: 1,
      limit: 10,
      totalPage: 1,
      pointList: [] // X币记录
    };
  },
  watch: {},
  computed: {},
  methods: {
    getPointLog() {
      let data = {
        page: this.page,
        limit: this.limit
      };

      this.$api.pointLog(data).then(res => {
        if (res.status) {
          this.totalPage = res.total;
          this.pointList = res.data;
        }
      });
    },
    handOrderMore(val) {
      this.page = val;
      this.getPointLog();
    }
  },
  created() {},
  mounted() {
    this.getPointLog();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .detail {
    &-title {
      color: #757575;
      line-height: 30px;
      margin-top: 10px;
      font-weight: 550;
      border-bottom: 1px solid $border;
    }
    &-nodata {
      margin: 30px auto;
      text-align: center;
    }
  }
}
</style>